import { Bot } from 'lucide-react';

export interface Message {
    id: string;
    type: 'user' | 'ai';
    text: string;
}

interface Props {
    message: Message;
}

export default function MessageBubble({ message }: Props) {
    const isUser = message.type === 'user';

    return (
        <div className={`flex ${isUser ? 'justify-end' : 'justify-start'} animate-in slide-in-from-bottom-1 duration-200`}>
            {!isUser && (
                <div className="w-7 h-7 sm:w-8 sm:h-8 rounded-full bg-primary/10 flex items-center justify-center flex-shrink-0 mr-2 mt-0.5">
                    <Bot className="w-4 h-4 text-primary" />
                </div>
            )}
            <div
                className={`max-w-[82%] sm:max-w-md px-3.5 py-2.5 rounded-2xl shadow-sm text-[15px] leading-relaxed whitespace-pre-wrap break-words ${
                    isUser
                        ? 'bg-primary text-white rounded-br-md'
                        : 'bg-white text-gray-800 border border-gray-200/70 rounded-bl-md'
                }`}
            >
                {message.text}
            </div>
        </div>
    );
}
